const papersDataCambridgeIgcse = {
  mathematics: [
    {
      year: '2025 (Specimen)',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/663662-2025-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663670-2025-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/663664-2025-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663672-2025-specimen-paper-2-mark-scheme.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/663666-2025-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663674-2025-specimen-paper-3-mark-scheme.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/663668-2025-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663676-2025-specimen-paper-4-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-May-June/0580_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-May-June/0580_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-May-June/0580_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_32.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-May-June/0580_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_42.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2023-May-June/0580_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2023-May-June/0580_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2023-May-June/0580_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2023-May-June/0580_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2023-May-June/0580_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2023-May-June/0580_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2023-May-June/0580_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2023-May-June/0580_s23_ms_41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/569923-june-2022-question-paper-11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/569924-june-2022-question-paper-21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/569925-june-2022-question-paper-31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/671439-june-2022-question-paper-41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_41.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-Oct-Nov/0580_w21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_ms_41.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2020-Oct-Nov/0580_w20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2020-May-June/0580_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2020-Oct-Nov/0580_w20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2020-May-June/0580_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2020-Oct-Nov/0580_w20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2020-May-June/0580_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2020-Oct-Nov/0580_w20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2020-May-June/0580_s20_ms_41.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2019-Oct-Nov/0580_w19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2019-Oct-Nov/0580_w19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2019-Oct-Nov/0580_w19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2019-Oct-Nov/0580_w19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2019-Oct-Nov/0580_w19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2019-Oct-Nov/0580_w19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2019-Oct-Nov/0580_w19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2019-Oct-Nov/0580_w19_ms_41.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_32.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_42.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_52.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_62.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_62.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_ms_42.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2023-May-June/0610_s23_ms_61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2019-May-June/0610_s19_ms_61.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2023-May-June/0620_s23_ms_61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_qp_13.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2019-May-June/0620_s19_ms_61.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2023-May-June/0625_s23_ms_61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-May-June/0625_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2019-May-June/0625_s19_ms_61.pdf',
        },
      ],
    },
  ],
  coordinatedscience: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/671101-2025-specimen-paper-1.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/671102-2025-specimen-paper-2.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://www.cambridgeinternational.org/Images/671103-2025-specimen-paper-3.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/671242-2025-specimen-paper-4.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/Images/671401-2025-specimen-paper-5.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cambridgeinternational.org/Images/671402-2025-specimen-paper-6.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2023-May-June/0654_s23_ms_61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/570109-june-2022-question-paper-11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/570111-june-2022-question-paper-21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://www.cambridgeinternational.org/Images/570110-june-2022-question-paper-31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/671320-june-2022-question-paper-41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/Images/671321-june-2022-question-paper-51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cambridgeinternational.org/Images/671322-june-2022-question-paper-61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2019-May-june/0654_s19_ms_61.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2023-May-June/0455_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2023-May-June/0455_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2023-May-June/0455_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2023-May-June/0455_s23_ms_21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_ms_22.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_ms_22.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2020-May-June/0455_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2020-May-June/0455_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2020-May-June/0455_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2020-May-June/0455_s20_ms_22.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2019-March/0455_m19_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2019-March/0455_m19_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2019-March/0455_m19_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2019-March/0455_m19_ms_22.pdf',
        },
      ],
    },
  ],
  businessstudies: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2023-May-June/0450_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2023-May-June/0450_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2023-May-June/0450_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2023-May-June/0450_s23_ms_21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2020-May-June/0450_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2020-May-June/0450_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2020-May-June/0450_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2020-May-June/0450_s20_ms_21.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2019-May-June/0450_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2019-May-June/0450_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2019-May-June/0450_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2019-May-June/0450_s19_ms_21.pdf',
        },
      ],
    },
  ],
  englishlanguage: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2023-May-June/0500_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2023-May-June/0500_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2023-May-June/0500_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2023-May-June/0500_s23_ms_21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2020-May-June/0500_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2020-May-June/0500_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2020-May-June/0500_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2020-May-June/0500_s20_ms_21.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2019-May-June/0500_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2019-May-June/0500_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2019-May-June/0500_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2019-May-June/0500_s19_ms_21.pdf',
        },
      ],
    },
  ],
  englishliterature: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2023-May-June/0475_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2023-May-June/0475_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2023-May-June/0475_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2023-May-June/0475_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2023-May-June/0475_s23_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2023-May-June/0475_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2023-May-June/0475_s23_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2023-May-June/0475_s23_ms_41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_41.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_41.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2020-May-June/0475_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2020-May-June/0475_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2020-May-June/0475_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2020-May-June/0475_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2020-May-June/0475_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2020-May-June/0475_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2020-May-June/0475_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2020-May-June/0475_s20_ms_41.pdf',
        },
      ],
    },
  ],
  additionalmathematics: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2023-May-June/0606_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2023-May-June/0606_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2023-May-June/0606_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2023-May-June/0606_s23_ms_21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2020-May-June/0606_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2020-May-June/0606_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2020-May-June/0606_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2020-May-June/0606_s20_ms_21.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2019-May-June/0606_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2019-May-June/0606_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2019-May-June/0606_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2019-May-June/0606_s19_ms_21.pdf',
        },
      ],
    },
  ],
  computerscience: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2023-May-June/0478_s23_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2023-May-June/0478_s23_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2023-May-June/0478_s23_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2023-May-June/0478_s23_ms_21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_ms_21.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2019-May-June/0478_s19_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2019-May-June/0478_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2019-May-June/0478_s19_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2019-May-June/0478_s19_ms_21.pdf',
        },
      ],
    },
  ],
};

export default papersDataCambridgeIgcse;
